export const ROOT_API = process.env.VUE_APP_ROOT_API
export const APP_TITLE = process.env.VUE_APP_TITLE
export const APP_HOMEPAGE = process.env.VUE_APP_HOMEPAGE
export const APP_LOCALE = process.env.VUE_APP_I18N_LOCALE
export const APP_ID = process.env.VUE_APP_I18N_LOCALE === 'tr' ? 1 : 2
